import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CoursePeriod from "./CoursePeriod.vue";
import util from "@/utils/plugins";
export default {
  name: "CourseChapter",
  components: {
    CoursePeriod: CoursePeriod
  },
  data: function data() {
    return {
      id: "",
      type: 0,
      chapters: [],
      chapterExpand: {},
      display_style: 0
    };
  },
  props: {
    course: {
      type: Object
    },
    currentPeriod: {
      type: String
    },
    tryText: {
      type: String,
      default: "试看"
    },
    // 是否来自点播页面
    isVideo: {
      type: Boolean,
      default: false
    },
    onPeriodTap: {
      type: Function
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  watch: {
    course: function () {
      var _course = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getData();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function course() {
        return _course.apply(this, arguments);
      }

      return course;
    }()
  },
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.id = this.course.id;
                this.type = this.course.course_type;
                _context3.next = 4;
                return this.getChapter();

              case 4:
                if (this.currentPeriod) {
                  this.chapters.forEach(function (c) {
                    if (!c.child) {
                      return;
                    }

                    c.child.forEach(function (p) {
                      if (p.id == _this.currentPeriod) {
                        _this.chapterExpand[c.id] = 1;
                      }
                    });
                  });
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    formatPeriod: function formatPeriod(period) {
      var teacherNames = [];

      if (period.teachers) {
        // period.teachers.forEach(t => {
        //   teacherNames.push(t.teacher_name);
        // });
        teacherNames = period.teachers;
      }

      period.teacher_name = teacherNames.join(",");
      var files = [];

      if (period.datum && period.datum.length > 0) {
        period.datum.forEach(function (item) {
          files.push({
            file_name: item.file_name,
            datum_id: item.datum_id,
            fid: item.fid.split(";"),
            file_ext: util.getFileType(item.file_name),
            file_url: item.file_url
          });
        });
      }

      period.files = files;
    },
    getChapter: function () {
      var _getChapter = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        var chapters;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.id) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                if (!(this.type == 9 || this.course.type == 4)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return");

              case 4:
                _context4.next = 6;
                return this.$http.post("/api/app/courseChapter", {
                  id: this.id
                });

              case 6:
                chapters = _context4.sent;

                if (chapters.length > 0) {
                  if (!chapters[0].periods_title) {
                    this.display_style = 1;
                    chapters.forEach(function (c) {
                      _this2.$set(_this2.chapterExpand, c.id, 0);

                      if (!c.child) {
                        return;
                      }

                      c.child.forEach(function (child) {
                        _this2.formatPeriod(child);
                      });
                    });
                  } else {
                    if (this.type != 3) {
                      chapters = chapters.filter(function (c) {
                        return c.parent_id != 0;
                      });
                    }

                    chapters.forEach(function (c) {
                      _this2.formatPeriod(c);
                    });
                  }
                }

                this.chapters = chapters;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChapter() {
        return _getChapter.apply(this, arguments);
      }

      return getChapter;
    }(),
    toggleExpand: function toggleExpand(id) {
      for (var key in this.chapterExpand) {
        if (key == id) {
          continue;
        }

        this.chapterExpand[key] = 0;
      }

      if (this.chapterExpand[id] == 0) {
        this.chapterExpand[id] = 1;
      } else {
        this.chapterExpand[id] = 0;
      }

      this.$emit("chapterClick", id);
    },
    getNextPeriod: function getNextPeriod(id) {
      var chapters = this.chapters;

      if (!chapters[0].periods_title) {
        chapters = chapters.filter(function (c) {
          return c.child && c.child.length > 0;
        });
        var c, p;
        var chapter;

        for (c = 0; c < chapters.length; c++) {
          chapter = chapters[c];

          if (!chapter.child) {
            return;
          }

          for (p = 0; p < chapter.child.length; p++) {
            var period = chapter.child[p];

            if (period.id == id) {
              break;
            }
          }

          if (p == chapter.child.length) {
            continue;
          }

          var nextPeriod = chapter.child[p + 1];

          if (nextPeriod) {
            return nextPeriod;
          }

          var nextChapter = chapters[c + 1];

          if (!nextChapter) {
            return;
          }

          return nextChapter.child[0];
        }
      } else {
        var i;

        for (i = 0; i < chapters.length; i++) {
          var _chapter = chapters[i];

          if (_chapter.id == id) {
            break;
          }
        }

        return chapters[i + 1];
      }
    }
  }
};